/**
 * Floating UI Bubbles
 *
 * Agrega aquí cualquier nueva burbuja flotante.
 * Este enum es la ÚNICA fuente de verdad.
 *
 * Reglas:
 * - La key es el identificador interno
 * - El value es el string que se usa en el estado
 */
export const BUBBLES = Object.freeze({
  MESSAGES: "messages",
  CALLS: "calls",

  // ASSISTANT: "assistant",
  // NOTIFICATIONS: "notifications",
});
